import React, {useState} from 'react';
import {G2, Pie, PieConfig} from '@ant-design/plots';
import {Plan} from '../types/Plan';
import {DonutChartData} from '../types/DonutChartData';
import {useHistory} from 'react-router';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowUpRightFromSquare} from '@fortawesome/free-solid-svg-icons';
import {Modal} from 'react-bootstrap';

interface DonutChartProps {
    title: string;
    data: DonutChartData[];
    idVerze: string;
    reduce?: boolean;
}

export const DonutChart: React.FC<DonutChartProps> = ({title, data, idVerze, reduce}) => {
    const [show, setShow] = useState(false);

    const height = show ? 600 : 300;
    const width = show ? 1200 : reduce ? 400 : 700;

    const {registerTheme} = G2;
    registerTheme('custom-theme', {
        colors10: ['#4175a8', '#6bd2db', '#FFC328', '#a81212', '#498f00', '#6350cc', '#FF745A', '#007E99', '#FFA8A8', '#2391FF'],
        colors20: [
            '#4175a8',
            '#6bd2db',
            '#FFC328',
            '#a81212',
            '#498f00',
            '#6350cc',
            '#FF745A',
            '#007E99',
            '#FFA8A8',
            '#2391FF',
            '#FFC328',
            '#A0DC2C',
            '#946DFF',
            '#626681',
            '#EB4185',
            '#CD8150',
            '#36BCCB',
            '#327039',
            '#803488',
            '#83BC99',
        ],
        styleSheet: {
            fontSize: 25,
        },
    });

    G2.registerInteraction('hover-cursor', {
        showEnable: [
            {trigger: 'element:mouseenter', action: 'cursor:pointer'},
            {trigger: 'element:mouseleave', action: 'cursor:default'},
        ],
    });

    const history = useHistory();

    const redirect = (idPlan: number) => {
        setShow(false);
        if (idPlan === null) {
            history.push('/strom/' + idVerze);
        } else {
            history.push('/strom/' + idVerze + '/' + idPlan);
        }
    };

    const config: PieConfig = {
        appendPadding: 40,
        onEvent: function (ii, i) {
            if (i.type === 'plot:click') {
                // @ts-ignore
                redirect(i.data.data.idPlan);
            }
        },
        data,
        height: height,
        width: width,
        autoFit: true,
        angleField: 'value',
        colorField: 'type',
        padding: 'auto',
        // animation: false,
        radius: 1,
        innerRadius: 0.7,
        legend: {
            maxRow: 3,
            position: 'bottom',
            offsetY: 10,
            itemSpacing: 0,
            marker: {
                symbol: 'square',
            },
        },
        label: {
            type: 'spider',
            labelHeight: 20,
            offset: '+100%',
            content: (data1, mappingData) => {
                return data1.type.length > 34 ? data1.type.substring(0, 34).trim() + '...' : data1.type;
            },
        },
        theme: 'custom-theme',
        tooltip: {
            customContent: (title, items) => {
                if (items.length == 0) {
                    return '';
                }
                const {name, value, color} = items[0];
                const label = '(' + new Intl.NumberFormat('cs-CS').format(value) + ' tis. Kč)';
                return (
                    <div>
                        <span
                            style={{
                                display: 'inline-flex',
                                flex: 1,
                                justifyContent: 'space-between',
                                marginTop: 10,
                                marginBottom: 10,
                            }}
                        >
                            <div
                                style={{
                                    width: 10,
                                    height: 10,
                                    marginRight: 10,
                                    backgroundColor: color,
                                }}
                            ></div>
                            <span style={{marginRight: 16}}>{name}:</span>
                            <span className="g2-tooltip-list-item-value">{label}</span>
                        </span>
                    </div>
                );
            },
        },
        interactions: [
            {
                type: 'element-active',
                cfg: {
                    start: [
                        {trigger: 'element:mouseenter', action: 'cursor:pointer'},
                        {trigger: 'element:mouseleave', action: 'cursor:default'},
                    ],
                },
            },
        ],

        statistic: {
            title: false,
            content: {
                style: {
                    whiteSpace: 'pre-wrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                content: '',
            },
        },
    };

    return (
        <div>
            {show ? (
                <Modal fullscreen show={show} onHide={() => setShow(false)} centered>
                    <Modal.Header className="centered" closeButton>
                        <h2>{title}</h2>
                    </Modal.Header>
                    <Modal.Body style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 50}}>
                        <div className="centered">
                            <Pie {...config} />
                        </div>
                    </Modal.Body>
                </Modal>
            ) : (
                <div>
                    <Pie {...config} />
                    <div className="class-col">
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="touchable" onClick={() => setShow(true)} />
                    </div>
                </div>
            )}
        </div>
    );
};
